<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  personalRating: string;
}>();

const ratingClasses = {
  neutral: "bg-secondary text-alternative-gray border border-divider",
  excellent: "bg-success text-white shadow-sm",
  bad: "bg-error/15 text-error border border-error/20",
  good: "bg-success/15 text-success border border-success/20",
  weak: "bg-secondary text-alternative-gray border border-divider",
};
</script>

<template>
  <span
    class="px-2.5 py-1 rounded-full text-xs font-bold inline-block"
    :class="ratingClasses[personalRating]"
  >
    {{
      $t(
        `calculators.personal-date.full-day-report.hourlyTable.ratings.${personalRating}`
      )
    }}
  </span>
</template>
